<template>
  <div class="header" :class="[{ 'header--searching header--white': searching }, type]">
    <!-- Left -->
    <div class="header__item header__item--left">
      <div class="icon" @click="goMenu" id="btn-menu">
        <svg>
          <use xlink:href="#icon-menu" />
        </svg>
      </div>
      <div class="header__item--menus">
        <slot name="left"></slot>
      </div>
    </div>

    <!-- Logo -->
    <div class="header__logo">
      <slot name="logo"></slot>
    </div>

    <nav class="header__menu" @mouseleave="moveline" ref="menu">
      <ul class="header__menu--wrapper">
        <li
          class="header__menu-item"
          :class="{ 'header__dropdown--open': open }"
          :key="item.id"
          v-for="item in menus"
          @mouseover="onover"
          @mouseenter="toggle(true, 'hover')"
          @mouseleave="toggle(false, 'hover')"
        >
          <a :href="item.LinkMenu"
            @click="pushDataLayer(item.Name), toggle()"
            :class="{ 'header__menu--icon': item.Items.length > 0 }"
          >
            {{ item.Name }}
          </a>
          <div>
            <transition name="header__dropdown--list-toggle">
              <ul
                v-if="item.Items.length > 0 && open"
                class="header__submenu header__dropdown--list"
              >
                <li v-for="submenuItem in item.Items" :key="submenuItem.id" class="header__submenu--item">
                  <a
                    :href="submenuItem.LinkMenu"
                    @click="pushDataLayer(item.Name, submenuItem.Name), toggle(false, 'nav')"
                    class="header__submenu--link"
                  >
                    {{ submenuItem.Name }}
                  </a>
                </li>
              </ul>
            </transition>
          </div>
        </li>
      </ul>
      <div class="header__menu--line">
        <div ref="arrow" class="arrow"></div>
      </div>
    </nav>

    <!-- Right -->
    <div class="header__item header__item--right">
      <div class="header__item--menus">
        <slot name="right"></slot>
      </div>

      <!-- Search -->
      <div v-if="!active" class="wrap-nt-autocomplete">
        <slot name="search"></slot>
      </div>

      <!-- Close -->
      <div v-else class="icon" @click.prevent="goClose">
        <svg class="close">
          <use xlink:href="#icon-close"></use>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'nt-header',
  props: {
    modifier: {
      type: String,
      default: null,
      required: true,
    },
    menus: Array,
    openOnHover: { type: Boolean, default: true },
  },
  data() {
    return {
      type: `header--${this.$props.modifier}`,
      active: false,
      searching: false,
      isMobile: false,
      open: false,
    }
  },
  computed: {
    ...mapGetters([
      'scrolling',
      'slider'
    ]),
  },
  watch: {
    slider(slider) {
      this.active = !!slider.active

      if (slider.active) {
        this.type = 'header--active'
      } else {
        this.type = this.checktype()
      }
    },
    scrolling() {
      if (this.slider.active) return

      this.type = this.checktype()
    },
    isMobile: {
      handler(newVal) {
        if (newVal && this.active) {
          this.goClose()
        }
      },
      immediate: true
    }
  },
  created() {
    this.$on('openSearch', (value) => {
      this.searching = value
    })
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  mounted() {
    this.handleResize()
  },
  methods: {
    ...mapActions([
      'updateSlider'
    ]),
    goMenu() {
      this.updateSlider({ type: 'menu', active: true })
    },
    goClose() {
      this.updateSlider({ type: undefined, active: false })
    },
    checktype() {
      return this.scrolling ? 'header--white' : `header--${this.modifier}`
    },
    onover(event) {
      const arrow = this.$refs.arrow
      const el = event.currentTarget

      if (arrow instanceof HTMLElement && !el.querySelector('.header__menu--icon')) {
        arrow.style.left = `${el.offsetLeft}px`
        arrow.style.width = `${el.offsetWidth}px`
      } else {
        arrow.style.left = 'unset'
        arrow.style.width = 'unset'
      }
    },
    moveline() {
      const arrow = this.$refs.arrow

      if (arrow instanceof HTMLElement) {
        arrow.style.left = 'unset'
        arrow.style.width = 'unset'
      }
    },
    pushDataLayer(name, suffix) {
      const label = suffix ? `${name} - ${suffix}` : name

      window.dataLayer.push({
        event: 'navigation',
        label,
      })
    },
    handleResize() {
      const isMobileView = window.innerWidth <= 1199

      if (isMobileView !== this.isMobile) {
        this.isMobile = isMobileView

        if (this.active && !isMobileView) {
          this.goClose()
        }
      }
    },
    toggle(value, origin = 'click') {
      if (origin === 'click' && this.openOnHover) return
      if (origin === 'hover' && !this.openOnHover) return
      this.open = value === undefined ? !this.open : value
    },
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;

  &__menu {
    position: relative;
    height: 100%;

    @media (max-width: 1199px) {
      display: none;
    }

    &--line {
      position: absolute;
      background: transparent;
      margin-top: -30px;
      & > .arrow {
        background-color: #9ddda9;
        display: table;
        height: 4px;
        position: absolute;
        transition: all 0.5s ease;
        top: -8px;
        left: 0;
      }
    }

    &--icon {
      width: 105px;

      @media screen and (min-width: 1280px) {
        width: 115px;
      }

      @media screen and (min-width: 1440px) {
        width: 135px;
      }

      &:hover {
        color: #3b3b3b;
      }

      &::after {
        content: "";
        display: inline-block;
        border: solid 0.4em transparent;
        border-top-color: initial;
        border-bottom-width: 0.125em;
        margin-top: 0.25em;
        margin-left: 1em;
      }

      &:hover::after {
        color: #3b3b3b;
      }
    }

    &--wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 100%;
      gap: 1rem;

      @media screen and (min-width: 1280px) {
        gap: 1.6rem;
      }

      @media screen and (min-width: 1440px) {
        gap: 2.8rem;
      }
    }

    &__item {
      width: 220px;
      margin-right: unset;
    }

    &-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      z-index: 1;
      cursor: pointer;
      position: relative;

      > div {
        position: absolute;
        top: 100%;
        background: transparent;
        z-index: 1;
        width: max-content;
      }

      &:last-child {
        margin-right: unset;
      }

      a {
        text-decoration: none;
        text-align: center;
        color: #fff;
        font-size: 18px;
      }

      &:has(.header__menu--icon):hover {
        height: 100%;
        background-color: #fff;

        > a {
          color: #3b3b3b;
        }
      }
    }
  }
}

.header--searching .header__item--right {
  width: 500px;
  z-index: 1;
}

.header__submenu {
  display: none;

  &--item {
    width: 105px;

    @media screen and (min-width: 1280px) {
      width: 115px;
    }

    @media screen and (min-width: 1440px) {
      width: 135px;
    }
  }

  &--link {
    color: #3b3b3b !important;
    fill: #3b3b3b;
    opacity: 1;
    padding: 1em 0.5em;
    display: inline-block;
    font-size: 16px !important;
    text-align: left !important;
    width: 100%;
    transition: background-color 0.2s;

    &:hover,
    &:focus {
      background-color: lighten(#9ddda9, 10%);
      color: #3b3b3b !important;
    }
  }
}

.header__menu-item:hover .header__menu--icon::after {
  color: #3b3b3b;
}

.header__menu-item:hover .header__submenu {
  display: table;
}

.header--white {
  .header__menu--icon {
    &:hover {
      color: #9ddda9 !important;
    }
    &:hover::after {
      color: #9ddda9;
    }
  }
}
</style>
